import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Button, Image } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { connect } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";
import NoContent from "../../../../reusableComponents/NoContentComponent";
// import { connect } from "socket.io-client";
import { getUserActivity } from "../../../../../store/actions/SuperAdminVUserViewActivity/userViewsActivity";
import { is } from "date-fns/locale";


const UserFavoriteReels = (props) => {
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(10);
    const [sort, setSort] = useState("");
    const [TrDetail, setTrDetail] = useState(false);
    const showTr = () => setTrDetail(!TrDetail);

    const handleBatchChange = (pageNo) => {
        window.scrollTo(0, 0);
        var calcStart = pageNo * 10 - 10;
        setStart(calcStart);
        setEnd(pageNo * 10);
        setPage(pageNo);
    };

    const onSuccesGetEvents = () => {
        setLoading(false);
    };
    const onErrorrGetEvents = () => {
        setLoading(false);
    };

    useEffect(() => {
        if (!isEmpty(props.dateQuery)){
            setLoading(true);
            let query = { ...props?.dateQuery, type:7, reportType:"ACTIVITY"};
            props.getUserActivity(query,onSuccesGetEvents,onErrorrGetEvents);
        }
    },[props.dateQuery]); 

    const [reels, setReels] = useState([]);

    useEffect(()=>{
        if (!isEmpty(props.userReelsActivity)) {
            const items = props.userReelsActivity?.data;
            setReels(items);
          }
    }, [props.userReelsActivity]);

    useEffect(() => {
        if(!isEmpty(props.sortValue)){
            setSort(props.sortValue);
        }
    },[props.sortValue]);

    

    return (
        <React.Fragment>
            <>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth900">
                        <thead>
                            <tr className="super_admin_all_users_table_head">
                                <th style={{ width: "20%" }}>
                                    Uploaded by
                                    <br />
                                    /Role/ID
                                </th>
                                <th style={{ width: "20%" }}>
                                    Reel/
                                    <br />
                                    ID
                                </th>
                                <th style={{ width: "20%" }}>Tapped</th>

                                <th style={{ width: "20%" }}>Viewed</th>
                                <th style={{ width: "15%" }}>Ordered/Booked</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="enUserFavoritesTableBody" onClick={showTr}>
                                <td style={{ width: "20%" }}>
                                    <div className="mt-2 f12-500"> StreetMeat</div>
                                    <div className="f10-400">merchant </div>
                                    <div className="f10-400">123456789</div>
                                </td>
                                <td style={{ width: "20%" }}>
                                    <div className="d-flex align-items-center">
                                        <div className="text-center d-flex flex-column align-items-center">
                                            <div className="enImage45">
                                                <Image />
                                            </div>
                                            <div className="text-break">
                                                <div className="f14-500 mt-2" style={{ color: "#2196F3" }}>1234567890</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td style={{ width: "20%" }}>
                                    <div className="f14-500">yes
                                        {/* {offer?.viewed ? "Yes" : "No"} */}
                                    </div>
                                </td>

                                <td style={{ width: "20%" }}>
                                    <div className="f14-500">
                                        {" "}
                                        {/* {item?.viewed ? "Yes" : "No"} */}
                                    </div>
                                    <div className="f14-500">
                                        {" "}
                                        {/* {moment(item.createdAt).format("LL")} */}
                                    </div>
                                    <div className="f14-500">
                                        {/* {moment(item.createdAt).format("LT")} */}
                                    </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                    <div className="f14-500">
                                        {" "}
                                        {/* {item?.viewed ? "Yes" : "No"} */}
                                    </div>
                                    <div className="f14-500">
                                        {" "}
                                        {/* {moment(item.createdAt).format("LL")} */}
                                    </div>
                                    <div className="f14-500">
                                        {/* {moment(item.createdAt).format("LT")} */}
                                    </div>
                                </td>
                            </tr>
                            {TrDetail && (
                                <>
                                    <tr className="sd_accordion_body border-top" style={{ background: "#ffffff" }}>
                                        <td style={{ width: "20%" }}>
                                            <div className="mt-2" style={{ marginBottom: "5%" }}>Liked</div>
                                            <div className="f14-500 mt-2">
                                                yes
                                            </div>
                                        </td>
                                        <td style={{ width: "20%" }}>
                                            <div className="mt-2" style={{ marginBottom: "5%" }}>Commented</div>
                                            <div className="f14-500 mt-2">Yes </div>
                                            <div>
                                                <Button variant="link" className="f10-500 text-blue" style={{ padding: 0 }}
                                                // onClick={handleSHowCount}
                                                >View Details</Button></div>
                                        </td>
                                        <td style={{ width: "20%" }}>
                                            <div className="mt" style={{ marginBottom: "5%" }}>Number of Times
                                                <br /> viewed
                                            </div>
                                            <div className="f12-400 mt-2">
                                                5
                                            </div>
                                        </td>
                                        <td style={{ width: "20%" }}>
                                            <div className="mt-2" style={{ marginBottom: "5%" }}>View Reel Details</div>
                                            <Button
                                                variant="link"
                                                className="enIconBtn mr-3"
                                            // onClick={this.onOpenModal}
                                            >
                                                <Image
                                                    src={require("../../../../../assets/images/UserManagement/eye.svg")}
                                                    alt="View"
                                                    title="View Details"
                                                    fluid
                                                />
                                            </Button>
                                        </td>
                                    </tr>
                                </>
                            )}

                        </tbody>

                    </Table>

                </div>

                <BasicPagination
                    //   totalRecords={}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                />

            </>



        </React.Fragment>

    )
}


  UserFavoriteReels.propTypes = {
    auth: PropTypes.object.isRequired,
    getUserActivity: PropTypes.func.isRequired,
  };
  
  const mapStateToProps = (state) => ({
    auth: state.auth,
    userReelsActivity: state.userManagement.userReelsActivity,
  });
  
  export default connect(mapStateToProps, {
    getUserActivity,
  })(UserFavoriteReels);
